import React from 'react';

export type LoadingVariant = 'fullPage' | 'inline' | 'button';

export interface LoadingStateProps {
  message?: string;
  variant?: LoadingVariant;
  /** Optional class for the wrapper */
  className?: string;
}

/**
 * Loading spinner with optional message. Replaces repeated loading divs across pages.
 */
export function LoadingState({
  message = 'Loading...',
  variant = 'inline',
  className,
}: LoadingStateProps) {
  if (variant === 'button') {
    return <span className={className}>{message}</span>;
  }

  const content = (
    <>
      <div className="spinner" />
      {message ? <p>{message}</p> : null}
    </>
  );

  if (variant === 'fullPage') {
    return <div className={`loading full-page ${className ?? ''}`.trim()}>{content}</div>;
  }

  return <div className={`loading ${className ?? ''}`.trim()}>{content}</div>;
}

export default LoadingState;
